import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ProjectStore, RecentlyViewedService } from '@frontend-site/shared/core';
import { Router } from '@angular/router';
import { MatSelectionList } from '@angular/material/list';
import { Observable, switchMap } from 'rxjs';
import { RecentlyItem } from '@frontend-site/shared/data';
import { UserService } from '@frontend-site/users/domain';

@Component({
    selector: 'p-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchComponent {
    @ViewChild('optionsList') matSelectionList: MatSelectionList = {} as MatSelectionList;
    @Output() closed = new EventEmitter<void>();
    recently$: Observable<RecentlyItem[]>;
    isExecuteIaUser = false;
    searchText = '';

    constructor(
        private readonly recentlyViewedService: RecentlyViewedService,
        private readonly projectStore: ProjectStore,
        private readonly userService: UserService,
        private router: Router
    ) {
        this.recently$ = projectStore.projectId$.pipe(
            switchMap((projectId) => {
                return this.recentlyViewedService.getItems(projectId);
            })
        );
        this.isExecuteIaUser = this.userService.isExecuteIaUser();
    }

    focusElemList() {
        this.focusOptions(this.matSelectionList);
    }

    focusOptions(optionsList: MatSelectionList) {
        optionsList?.focus();
    }

    navigate(routePath: string) {
        this.closed.emit();
        this.router.navigateByUrl(routePath);
    }

    onSearch(value: string): void {
        this.closed.emit();
        if (value != '') {
            value = encodeURIComponent(value).replace(/\(/g, '%28').replace(/\)/g, '%29');
            this.router.navigateByUrl(`${this.projectStore.projectId}/globalSearch/${value}`);
        }
    }
}
